// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page wrapper ── */
.cert-det-page {
  display: flex;
  justify-content: center;
  padding: 24px 16px 64px;
  min-height: 100%;
}

.cert-det-container {
  width: 100%;
  max-width: 780px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Back button ── */
.cert-det-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #9aa3ad;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s ease;
  width: fit-content;
}

.cert-det-back:hover {
  color: #48D1CC;
}

/* ── Hero card ── */
.cert-det-hero {
  background: #0e1b1b;
  border-radius: 20px;
  border: 1px solid #484848;
  padding: 24px;
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.cert-det-hero-skeleton {
  min-height: 180px;
}

.cert-det-badge-icon {
  width: 80px;
  height: 80px;
  min-width: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cert-det-hero-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cert-det-name-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: wrap;
}

.cert-det-name {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.3;
}

/* ── Status pills ── */
.cert-det-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 20px;
  padding: 4px 10px;
  white-space: nowrap;
  align-self: center;
}

.cert-det-pill-completed { background: rgba(59, 179, 174, 0.15); color: #48D1CC; }
.cert-det-pill-failed    { background: rgba(239, 83, 80, 0.12); color: #ef5350; }
.cert-det-pill-expired   { background: rgba(255, 167, 38, 0.12); color: #ffa726; }

.cert-det-description {
  margin: 0;
  font-size: 14px;
  color: #9aa3ad;
  line-height: 1.6;
}

/* ── Meta chips ── */
.cert-det-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cert-det-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #071414;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 12px;
  color: #9aa3ad;
}

.cert-det-meta-pass {
  color: #48D1CC;
  font-weight: 600;
}

/* ── CTA row ── */
.cert-det-cta-row {
  padding-top: 4px;
}

/* ── Buttons ── */
.cert-det-btn {
  padding: 10px 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.cert-det-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cert-det-btn:not(:disabled):hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

.cert-det-btn-enroll {
  background: rgba(59, 179, 174, 0.15);
  color: #48D1CC;
  border: 1px solid #3BB3AE;
}

.cert-det-btn-start {
  background: linear-gradient(135deg, #3BB3AE, #0099a8);
  color: #fff;
}

.cert-det-btn-exam {
  background: linear-gradient(135deg, #3BB3AE, #0099a8);
  color: #fff;
}

.cert-det-btn-view {
  background: rgba(59, 179, 174, 0.15);
  color: #48D1CC;
  border: 1px solid rgba(75, 227, 207, 0.25);
}

/* ── Tabs wrapper ── */
.cert-det-tabs-wrap {
  background: #0e1b1b;
  border-radius: 18px;
  border: 1px solid #484848;
  overflow: hidden;
}

.cert-det-tab-panel {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Overview section card ── */
.cert-det-section-card {
  background: #071414;
  border-radius: 14px;
  padding: 16px;
}

.cert-det-section-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: #e6eaef;
}

.cert-det-section-body {
  margin: 0;
  font-size: 14px;
  color: #9aa3ad;
  line-height: 1.65;
}

/* ── Stats grid ── */
.cert-det-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.cert-det-stat {
  background: #071414;
  border-radius: 14px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.cert-det-stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #48D1CC;
}

.cert-det-stat-label {
  font-size: 12px;
  color: #9aa3ad;
  text-align: center;
}

/* ── Modules list ── */
.cert-det-modules-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cert-det-module-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #071414;
  border-radius: 14px;
  padding: 14px;
}

.cert-det-module-num {
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 50%;
  background: rgba(59, 179, 174, 0.15);
  color: #48D1CC;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cert-det-module-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cert-det-module-title {
  font-size: 15px;
  font-weight: 600;
  color: #e6eaef;
}

.cert-det-module-desc {
  font-size: 13px;
  color: #9aa3ad;
  line-height: 1.5;
}

.cert-det-modules-cta {
  padding-top: 8px;
}

/* ── Empty state ── */
.cert-det-empty {
  color: #9aa3ad;
  text-align: center;
  padding: 32px 16px;
}

/* ── Skeletons ── */
.cert-skeleton {
  border-radius: 8px;
  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);
  background-size: 200% 100%;
  animation: certDetSkeleton 1.4s ease infinite;
}

.cert-skel-badge-lg  { width: 80px; height: 80px; border-radius: 20px; }
.cert-skel-title-lg  { width: 60%; height: 22px; margin-bottom: 10px; }
.cert-skel-sub       { width: 85%; height: 14px; margin-bottom: 10px; }
.cert-skel-meta-row  { width: 90%; height: 14px; }
.cert-skel-body      { width: 100%; height: 120px; border-radius: 18px; }

@keyframes certDetSkeleton {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .cert-det-hero {
    flex-direction: column;
  }

  .cert-det-stats-grid {
    grid-template-columns: 1fr 1fr;
  }

  .cert-det-name {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Certifications/CertificationDetail/CertificationDetail.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2BAA2B,oCAAoC,EAAE,cAAc,EAAE;AACjF,2BAA2B,mCAAmC,EAAE,cAAc,EAAE;AAChF,2BAA2B,oCAAoC,EAAE,cAAc,EAAE;;AAEjF;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA,uBAAuB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACvE,uBAAuB,UAAU,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACtE,uBAAuB,UAAU,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACtE,uBAAuB,UAAU,EAAE,YAAY,EAAE;AACjD,uBAAuB,WAAW,EAAE,aAAa,EAAE,mBAAmB,EAAE;;AAExE;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,qBAAqB;AACrB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ── Page wrapper ── */\n.cert-det-page {\n  display: flex;\n  justify-content: center;\n  padding: 24px 16px 64px;\n  min-height: 100%;\n}\n\n.cert-det-container {\n  width: 100%;\n  max-width: 780px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Back button ── */\n.cert-det-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: #9aa3ad;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.15s ease;\n  width: fit-content;\n}\n\n.cert-det-back:hover {\n  color: #48D1CC;\n}\n\n/* ── Hero card ── */\n.cert-det-hero {\n  background: #0e1b1b;\n  border-radius: 20px;\n  border: 1px solid #484848;\n  padding: 24px;\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.cert-det-hero-skeleton {\n  min-height: 180px;\n}\n\n.cert-det-badge-icon {\n  width: 80px;\n  height: 80px;\n  min-width: 80px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cert-det-hero-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.cert-det-name-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.cert-det-name {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.3;\n}\n\n/* ── Status pills ── */\n.cert-det-status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 20px;\n  padding: 4px 10px;\n  white-space: nowrap;\n  align-self: center;\n}\n\n.cert-det-pill-completed { background: rgba(59, 179, 174, 0.15); color: #48D1CC; }\n.cert-det-pill-failed    { background: rgba(239, 83, 80, 0.12); color: #ef5350; }\n.cert-det-pill-expired   { background: rgba(255, 167, 38, 0.12); color: #ffa726; }\n\n.cert-det-description {\n  margin: 0;\n  font-size: 14px;\n  color: #9aa3ad;\n  line-height: 1.6;\n}\n\n/* ── Meta chips ── */\n.cert-det-meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.cert-det-meta-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: #071414;\n  border-radius: 20px;\n  padding: 4px 12px;\n  font-size: 12px;\n  color: #9aa3ad;\n}\n\n.cert-det-meta-pass {\n  color: #48D1CC;\n  font-weight: 600;\n}\n\n/* ── CTA row ── */\n.cert-det-cta-row {\n  padding-top: 4px;\n}\n\n/* ── Buttons ── */\n.cert-det-btn {\n  padding: 10px 24px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.cert-det-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cert-det-btn:not(:disabled):hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.cert-det-btn-enroll {\n  background: rgba(59, 179, 174, 0.15);\n  color: #48D1CC;\n  border: 1px solid #3BB3AE;\n}\n\n.cert-det-btn-start {\n  background: linear-gradient(135deg, #3BB3AE, #0099a8);\n  color: #fff;\n}\n\n.cert-det-btn-exam {\n  background: linear-gradient(135deg, #3BB3AE, #0099a8);\n  color: #fff;\n}\n\n.cert-det-btn-view {\n  background: rgba(59, 179, 174, 0.15);\n  color: #48D1CC;\n  border: 1px solid rgba(75, 227, 207, 0.25);\n}\n\n/* ── Tabs wrapper ── */\n.cert-det-tabs-wrap {\n  background: #0e1b1b;\n  border-radius: 18px;\n  border: 1px solid #484848;\n  overflow: hidden;\n}\n\n.cert-det-tab-panel {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Overview section card ── */\n.cert-det-section-card {\n  background: #071414;\n  border-radius: 14px;\n  padding: 16px;\n}\n\n.cert-det-section-title {\n  margin: 0 0 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e6eaef;\n}\n\n.cert-det-section-body {\n  margin: 0;\n  font-size: 14px;\n  color: #9aa3ad;\n  line-height: 1.65;\n}\n\n/* ── Stats grid ── */\n.cert-det-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.cert-det-stat {\n  background: #071414;\n  border-radius: 14px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.cert-det-stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #48D1CC;\n}\n\n.cert-det-stat-label {\n  font-size: 12px;\n  color: #9aa3ad;\n  text-align: center;\n}\n\n/* ── Modules list ── */\n.cert-det-modules-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.cert-det-module-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  background: #071414;\n  border-radius: 14px;\n  padding: 14px;\n}\n\n.cert-det-module-num {\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  border-radius: 50%;\n  background: rgba(59, 179, 174, 0.15);\n  color: #48D1CC;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cert-det-module-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.cert-det-module-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #e6eaef;\n}\n\n.cert-det-module-desc {\n  font-size: 13px;\n  color: #9aa3ad;\n  line-height: 1.5;\n}\n\n.cert-det-modules-cta {\n  padding-top: 8px;\n}\n\n/* ── Empty state ── */\n.cert-det-empty {\n  color: #9aa3ad;\n  text-align: center;\n  padding: 32px 16px;\n}\n\n/* ── Skeletons ── */\n.cert-skeleton {\n  border-radius: 8px;\n  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);\n  background-size: 200% 100%;\n  animation: certDetSkeleton 1.4s ease infinite;\n}\n\n.cert-skel-badge-lg  { width: 80px; height: 80px; border-radius: 20px; }\n.cert-skel-title-lg  { width: 60%; height: 22px; margin-bottom: 10px; }\n.cert-skel-sub       { width: 85%; height: 14px; margin-bottom: 10px; }\n.cert-skel-meta-row  { width: 90%; height: 14px; }\n.cert-skel-body      { width: 100%; height: 120px; border-radius: 18px; }\n\n@keyframes certDetSkeleton {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n  .cert-det-hero {\n    flex-direction: column;\n  }\n\n  .cert-det-stats-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .cert-det-name {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
